module.exports = __webpack_public_path__ + "media/images/countryrect/de-a6848e603ddaa775c97cf0b48efd71b2.svg";